import React from 'react';
import GMGAssistant from './ACEPortal';

function App() {
  return <GMGAssistant />;
}

export default App;
